import { Component } from '@angular/core';

import { PeopleListComponent } from '../people-list/people-list.component';
import { PeopleTabConfig } from '../people-list/people-tab-config';

@Component({
    selector: 'app-people-customers',
    standalone: true,
    imports: [PeopleListComponent],
    template: `<app-people-list [config]="config"></app-people-list>`,
})
export class PeopleCustomersComponent {
    config: PeopleTabConfig = {
        title: 'Customers',
        roleAttributes: ['customer'],
        showCreate: false,
        showInvite: false,
        showNewOpportunity: true,
        showCreateCrew: false,
        showJobs: true,
        showRoleFilter: false,
    };
}